var _style, _g, _path, _g2, _g3, _ellipse, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path2, _defs, _g12, _g13, _path3, _path4, _g14, _g15, _g16, _g17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EAEFF4;}\n\t.st1{fill:#1054D7;}\n\t.st2{fill:#054BAF;}\n\t.st3{fill:#011843;}\n\t.st4{fill:none;stroke:#011843;stroke-width:2.6579;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#011843;stroke-width:2.6579;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#DBE2EF;stroke-width:0.8184;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#D4DBE8;}\n\t.st8{fill:#2F99F1;}\n\t.st9{fill:none;stroke:#DBE2EF;stroke-width:0.6645;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#DBE2EF;stroke-width:0.6645;stroke-miterlimit:10;}\n\t.st11{fill:#F4F4F4;}\n\t.st12{fill:none;stroke:#011843;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#2F99F1;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#011843;stroke-miterlimit:10;}\n\t.st15{fill:#5C9EFF;}\n\t.st16{fill:none;stroke:#DBE2EF;stroke-width:0.8184;stroke-miterlimit:10;}\n\t.st17{fill:#FF6258;}\n\t.st18{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st19{fill:#122A51;}\n\t.st20{fill:none;stroke:#546177;stroke-width:0.886;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{opacity:0.44;}\n\t.st22{clip-path:url(#SVGID_2_);}\n\t.st23{fill:none;stroke:#B0BFD6;stroke-width:0.9724;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#011843;stroke-width:0.886;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:#ADCCF2;}\n\t.st26{fill:#6E97F4;}\n\t.st27{fill:#BFD0F7;}\n\t.st28{fill:#163466;}\n\t.st29{fill:#B5D3F4;}\n\t.st30{fill:#7E95E0;}\n\t.st31{fill:#7999D3;}\n\t.st32{fill:none;stroke:#011843;stroke-width:0.9724;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st33{fill:#9AAECC;}\n\t.st34{fill:#213E66;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.98,226c0.35,14.42-1.18,28.97-4.78,43.3c-13.16,52.51-54,101.23-105.92,120.57 c-80.01,29.8-156.56-10.75-203.89-74.51c-37.11-50-32.36-125.65-0.39-177.07c3.35-5.38,7.01-10.57,10.99-15.52 c55.9-69.56,170.13-87.97,240.06-28.38C405.02,127.59,428.77,176.06,429.98,226z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.52,193.33h75.84c12.86,0,22.89,11.12,21.56,23.91c-2.14,20.64-8.93,50.96-11.8,75.71 c-2.51,21.66-20.85,38-42.65,38h-68.51L283.52,193.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.07,193.33h72.25c12.86,0,22.89,11.12,21.56,23.91c-2.14,20.64-5.35,39.34-8.21,64.09 c-2.51,21.66-20.85,38-42.65,38h-68.51L274.07,193.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300.65,
    y: 331.76,
    className: "st3",
    width: 8.86,
    height: 111.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325.52,334.4h-46.19c-1.62,0-2.93-1.31-2.93-2.93v-0.59h52.05v0.59 C328.45,333.09,327.14,334.4,325.52,334.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.76,453.66L268.76,453.66c0-6.36,5.16-11.52,11.52-11.52h53.16c6.36,0,11.52,5.16,11.52,11.52v0.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 323.8,
    y1: 453.55,
    x2: 323.8,
    y2: 442.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 289.24,
    y1: 453.55,
    x2: 289.24,
    y2: 442.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 269.67,
    cy: 453.84,
    r: 5.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 269.67,
    cy: 453.84,
    r: 1.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 289.67,
    cy: 453.84,
    r: 5.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 289.67,
    cy: 453.84,
    r: 1.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 324.8,
    cy: 453.84,
    r: 5.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 324.8,
    cy: 453.84,
    r: 1.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 344.8,
    cy: 453.84,
    r: 5.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 344.8,
    cy: 453.84,
    r: 1.75
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M168.64,280.53l10.23,177.31c0.01,2.64-3.56,2.78-3.71,0.14l-19.48-177.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "155.69,280.49 168.65,280.54 156.39,286.75  "
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 250.47,
    cy: 463.05,
    rx: 232.25,
    ry: 3.92
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M154.52,169.14h-51.09c-5.92,0-10.4-5.34-9.38-11.17l4.57-26.13c0.8-4.56,4.76-7.88,9.38-7.88h51.09 c5.92,0,10.4,5.34,9.38,11.17l-4.57,26.13C163.11,165.82,159.15,169.14,154.52,169.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.36,165.39h10.41c3.99,0,7.47-2.69,8.52-6.54c0.91-3.35,1.26-6.66,2.07-9.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.41,166.4l5,9.84c0.98,1.93,3.24,2.16,4.48,0.46l7.8-10.74"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 116.63,
    cy: 145.58,
    r: 2.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M133.95,145.58c0,1.48-1.2,2.68-2.68,2.68c-1.48,0-2.68-1.2-2.68-2.68c0-1.48,1.2-2.68,2.68-2.68 C132.75,142.9,133.95,144.1,133.95,145.58z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 145.89,
    cy: 145.58,
    r: 2.68
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M162.23,145.06c0.27-1.28,0.55-2.56,0.82-3.84"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2323 -0.9726 0.9726 0.2323 76.2848 300.6296)",
    className: "st11",
    cx: 228.59,
    cy: 101.99,
    rx: 26.04,
    ry: 26.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M245.09,103.72v-2.75c0-0.71-0.58-1.28-1.28-1.28h-1.15c-0.97,0-1.8-0.64-2.11-1.56 c-0.08-0.24-0.17-0.47-0.26-0.7c-0.38-0.93-0.07-2,0.71-2.64l0.79-0.65c0.55-0.44,0.63-1.25,0.18-1.79l-1.75-2.15 c-0.44-0.55-1.25-0.63-1.79-0.18l-1,0.82c-0.82,0.67-1.95,0.72-2.88,0.22c-0.52-0.28-1.05-0.52-1.61-0.73 c-1.01-0.37-1.71-1.29-1.71-2.37v-1.09c0-0.64-0.52-1.15-1.15-1.15h-3.01c-0.64,0-1.15,0.52-1.15,1.15v1.15 c0,1.04-0.68,1.94-1.66,2.29c-0.62,0.22-1.21,0.5-1.77,0.81c-0.89,0.49-1.97,0.43-2.76-0.21l-0.84-0.68 c-0.69-0.56-1.7-0.46-2.26,0.23l-1.33,1.63c-0.56,0.69-0.46,1.7,0.23,2.26l0.83,0.68c0.68,0.55,0.88,1.49,0.54,2.3 c-0.14,0.32-0.26,0.66-0.37,0.99c-0.26,0.81-1,1.38-1.85,1.38h-1.31c-0.71,0-1.28,0.57-1.28,1.28v2.75c0,0.71,0.57,1.28,1.28,1.28 h1.52c0.78,0,1.46,0.5,1.71,1.24c0.16,0.48,0.35,0.94,0.57,1.39c0.34,0.7,0.2,1.53-0.34,2.07l-1.05,1.05 c-0.51,0.51-0.51,1.33,0,1.84l1.92,1.92c0.51,0.51,1.33,0.51,1.84,0l0.52-0.52c0.76-0.76,1.92-0.98,2.87-0.5 c0.44,0.22,0.9,0.42,1.37,0.58c0.98,0.35,1.61,1.32,1.61,2.36v0.64c0,0.65,0.53,1.18,1.18,1.18h2.95c0.65,0,1.18-0.53,1.18-1.18 v-0.86c0-0.97,0.63-1.8,1.55-2.12c0.54-0.19,1.07-0.42,1.58-0.68c0.89-0.46,1.98-0.22,2.66,0.51l0.66,0.71 c0.5,0.54,1.35,0.57,1.89,0.07l1.94-1.8c0.54-0.5,0.57-1.35,0.07-1.89l-1.06-1.14c-0.65-0.7-0.78-1.72-0.39-2.59 c0.1-0.23,0.2-0.47,0.29-0.71c0.36-0.97,1.32-1.59,2.36-1.59h1.04C244.52,105,245.09,104.43,245.09,103.72z M228.57,108.6 c-3.54,0-6.42-2.87-6.42-6.42s2.87-6.42,6.42-6.42c3.54,0,6.42,2.87,6.42,6.42S232.12,108.6,228.57,108.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M394.81,241.3c-1.28,0-2.25,1.15-2.03,2.41l3.46,19.82c0.62,2.51,2.87,4.27,5.45,4.27h9.18 c2.63,0,4.9-1.82,5.48-4.39l2.7-19.78c0.17-1.23-0.79-2.33-2.04-2.33H394.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M398.69,253.72c0,2.95-2.39,5.33-5.33,5.33s-5.33-2.39-5.33-5.33c0-2.95,2.39-5.33,5.33-5.33 S398.69,250.78,398.69,253.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M411.23,241.25c-0.33-2.21,0.19-4.46,1.49-6.03c1.16-1.41,2.66-2.54,3.46-4.22c0.92-1.93,1.2-4.12,0.82-6.22 c-0.41-2.29-1.64-4.61-3.52-6.03c-2.53-1.93-5.58-1.55-8.57-1.71c-0.39-0.02-0.79-0.05-1.18-0.1c-4.63-0.62-6.25-4-8.97-8.92 c-0.48,2.39-0.97,4.81-0.79,7.24c0.18,2.43,1.11,4.91,3.01,6.43c3.18,2.55,7.95,0.46,11.32,2.75c0.9,0.61,2.06,2.12,2.25,3.19 c0.35,1.95-1.56,4.69-3.46,5.17c-1.92,0.49-3.86,0.3-5.55,1.33c-1.69,1.03-2.25,3.25-2.25,5.23c0,1.13,0.04,1.9,0.04,1.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 394.03,
    y1: 249.55,
    x2: 418.11,
    y2: 249.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 395.44,
    y1: 257.14,
    x2: 416.94,
    y2: 257.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.11,260.06c0.39-4.06,0.79-8.12,1.18-12.18"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.44,86.05l0.08-0.06c0.4-0.29,0.48-0.85,0.2-1.24l-4.55-6.24c-0.29-0.4-0.85-0.48-1.24-0.2l0,0 c-2.62,1.91-6.28,1.33-8.19-1.29l-4.87-6.69c-1.91-2.62-1.33-6.28,1.29-8.19l0,0c0.4-0.29,0.48-0.85,0.2-1.24l-3.66-5.03 c-0.29-0.4-0.85-0.48-1.24-0.2l-0.08,0.06c-5.36,3.91-6.54,11.42-2.64,16.78l7.94,10.89C138.56,88.77,146.08,89.95,151.44,86.05z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 150.36,
    cy: 65.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 169.36,
    cy: 65.06,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 159.36,
    cy: 65.06,
    r: 2.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M366.98,153.71l1.46,10.45c0.29,2.05,1.9,2.67,3.21,1.22l8.23-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M409.68,158.72h-71.01c-4.08,0-7.09-3.8-6.16-7.77l5.02-21.35c0.67-2.86,3.22-4.88,6.16-4.88h71.01 c4.08,0,7.09,3.8,6.16,7.77l-5.02,21.35C415.17,156.7,412.62,158.72,409.68,158.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M401.57,155.35h4.83c2.95,0,5.52-2,6.24-4.86l1.6-6.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M415.01,141.06c0.17-0.75,0.33-1.5,0.5-2.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 348.86,
    y1: 131.55,
    x2: 409.96,
    y2: 131.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 346.36,
    y1: 139.55,
    x2: 386.37,
    y2: 139.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 344.36,
    y1: 146.55,
    x2: 396.4,
    y2: 146.55
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.07,279.15L68.15,457.7c-0.16,2.64,3.4,3.01,3.7,0.39l30.16-178.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "88.91,280.49 102.2,280.54 88.17,286.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.86,279.15l20.92,180.24c0.16,2.64-3.4,3.01-3.7,0.39l-30.16-179.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "428.93,280.49 442.11,280.49 430.07,286.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M361.82,280.49l-9.42,176.93c-0.01,2.64,3.56,2.78,3.71,0.14L375,280.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "361.82,280.49 375,280.49 361.52,286.95  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 67.37,
    y: 267.89,
    className: "st15",
    width: 388.02,
    height: 12.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.97,
    y: 267.89,
    className: "st8",
    width: 246.47,
    height: 12.64
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M222.36,186.39c0,1.84-1.49,3.33-3.33,3.33c-1.84,0-3.33-1.49-3.33-3.33c0-1.84,1.49-3.33,3.33-3.33 C220.87,183.05,222.36,184.55,222.36,186.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M314.03,112.39c0,1.84-1.49,3.33-3.33,3.33c-1.84,0-3.33-1.49-3.33-3.33c0-1.84,1.49-3.33,3.33-3.33 C312.53,109.06,314.03,110.55,314.03,112.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M395.36,182.05c0,1.84-1.49,3.33-3.33,3.33c-1.84,0-3.33-1.49-3.33-3.33c0-1.84,1.49-3.33,3.33-3.33 C393.87,178.72,395.36,180.21,395.36,182.05z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 155.36,
    cy: 193.05,
    r: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M185.75,178.11c0,1.26-1.02,2.28-2.28,2.28c-1.26,0-2.28-1.02-2.28-2.28s1.02-2.28,2.28-2.28 C184.73,175.83,185.75,176.85,185.75,178.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M240.69,157.72c0,1.26-1.02,2.28-2.28,2.28s-2.28-1.02-2.28-2.28c0-1.26,1.02-2.28,2.28-2.28 S240.69,156.46,240.69,157.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M182.03,103.39c0,1.26-1.02,2.28-2.28,2.28c-1.26,0-2.28-1.02-2.28-2.28c0-1.26,1.02-2.28,2.28-2.28 C181.01,101.11,182.03,102.13,182.03,103.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M365.36,180.39c0,1.26-1.02,2.28-2.28,2.28s-2.28-1.02-2.28-2.28c0-1.26,1.02-2.28,2.28-2.28 S365.36,179.13,365.36,180.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M104.03,213.72c0,1.26-1.02,2.28-2.28,2.28c-1.26,0-2.28-1.02-2.28-2.28c0-1.26,1.02-2.28,2.28-2.28 C103.01,211.44,104.03,212.46,104.03,213.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 194.49,
    y1: 142.59,
    x2: 194.49,
    y2: 135.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 190.96,
    y1: 139.05,
    x2: 198.03,
    y2: 139.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 273.16,
    y1: 83.26,
    x2: 273.16,
    y2: 76.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 269.62,
    y1: 79.72,
    x2: 276.69,
    y2: 79.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 337.16,
    y1: 177.92,
    x2: 337.16,
    y2: 170.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 333.62,
    y1: 174.39,
    x2: 340.69,
    y2: 174.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 109.82,
    y1: 246.59,
    x2: 109.82,
    y2: 239.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 106.29,
    y1: 243.05,
    x2: 113.36,
    y2: 243.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 141.16,
    y1: 301.26,
    x2: 141.16,
    y2: 294.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 137.62,
    y1: 297.72,
    x2: 144.69,
    y2: 297.72
  })))), /*#__PURE__*/React.createElement("g", null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M230.89,424.89c-0.58-3.74-2.53-8.69-3.36-12.38c0.46-0.29,18.11-6.89,22.49-8.27l4.78,20.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.15,307.79h-7.13c0,0,9.83,20.27,17.83,43.77c12.23,35.92,14.92,55.15,14.92,55.15l-49.11,11.26 l-32.02-115.78c0,0-5.6-13.24,2.55-21.89h70.78L233.15,307.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.18,424.06l6.25,35.11h-16.96l-2.59-12.58l-8.49,12.58h-30.61l-0.06-2.03 c-0.09-4.21,2.67-7.97,6.74-9.05c8-2.12,18.48-7.55,21.31-23.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M230.3,436.61c-0.82-0.93-1.64-1.86-2.46-2.79c1.91-0.36,3.35-1.2,5.26-1.56 c-1.41-0.76-3.07-1.71-4.49-2.47c1.78-0.68,5.24-2.26,5.24-2.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M170.04,418.86c0,0,8.08-12.77,10.37-15.78c0.52,0.17,16.92,9.44,20.8,11.92l-12.36,16.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.09,428.04l-14,32.8l-14.19-9.29l4.73-11.94l-13.99,5.88l-25.61-16.77l1.06-1.73 c2.23-3.57,6.6-5.21,10.6-3.88c7.85,2.6,19.6,3.81,30.56-7.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M165.68,425.23c-0.79-1.41-1.5-2.86-2.12-4.35c2.11,0.32,4.19,0.72,6.3,1.04 c-0.74-1.72-1.6-3.64-2.34-5.36c1.89,0.77,3.8,1.37,5.69,2.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M292.62,312.23h16.32c11.59,0,23.46-5.62,24.43-17.17c0.67-8-3.43-14.76-3.43-14.76h-80.99 c0,0-28.84,26.05-51.58,56.26c-28.92,38.44-38.26,56.46-38.26,56.46l47.97,28.85l72.08-102.64 C282.24,314.83,287.26,312.23,292.62,312.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M202.86,418.3c24.93-33.41,48.95-69.69,73.48-103.94c3.11-4.34,8.4-6.57,13.73-6.72l31.43-0.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 169.31,
    y1: 382.15,
    x2: 215.02,
    y2: 409.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M244.07,295.1c2.41-2.59,4.82-5.17,7.24-7.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M250.39,292.07c-1.51,2.87-2.75,5.88-3.7,8.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M167.78,390.5c4.35-6.15,8.7-12.31,13.05-18.46"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M334.93,206.15c-0.28-7.34-1.61-12.74-7.45-18.43c-2.2-2.15-4.91-4.55-7.81-6.01 c-4.22-2.12-9.71-2.95-13.74-4.86l-5.96-7.29l-11.35,1.05l-7.89-1.58c-5.14,9.91-22.43,10.38-30.96,18.69 c-5.84,5.69-7.17,11.09-7.45,18.43c-0.74,19.17,1.86,61.75,1.86,61.75h38.91h11.05h36.1 C330.25,267.89,335.67,225.31,334.93,206.15z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st21",
    d: "M356.13,248.28c-2.97-11.72-6.7-23.56-11-34c-3.26-7.91-6.97-15.75-12.45-22.33 c-5.28-6.34-12.4-11.45-20.47-13.06c-2.22-0.66-4.41-1.31-6.28-2.2l-5.96-7.29l-11.35,1.05l-7.89-1.58 c-5.14,9.91-22.43,10.38-30.96,18.69c-5.84,5.69-7.17,11.09-7.45,18.43c-0.74,19.17,1.86,61.75,1.86,61.75h38.91h11.05h36.1 c0,0,0.11-0.84,0.29-2.33c3.66,0.27,7.23,0.53,10.56,0.77C350.9,266.89,358.55,257.8,356.13,248.28z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 332.84,
    y1: 279.89,
    x2: 332.84,
    y2: 169.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 314.43,
    y1: 277.29,
    x2: 314.43,
    y2: 169.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 296.02,
    y1: 280.21,
    x2: 296.02,
    y2: 169.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 277.54,
    y1: 273.73,
    x2: 277.67,
    y2: 169.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 259.2,
    y1: 281.21,
    x2: 259.2,
    y2: 169.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 240.79,
    y1: 278.27,
    x2: 240.79,
    y2: 169.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 229.12,
    y1: 193.67,
    x2: 351.32,
    y2: 193.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 229.12,
    y1: 210.2,
    x2: 351.32,
    y2: 210.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 229.12,
    y1: 227.38,
    x2: 351.32,
    y2: 227.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 229.12,
    y1: 244.56,
    x2: 351.32,
    y2: 245.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 229.12,
    y1: 261.74,
    x2: 351.32,
    y2: 261.74
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M254.61,230.56c0.78,9.78,2.23,21.51,3.77,31.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 284.71,
    y1: 179.85,
    x2: 288.88,
    y2: 187.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "284.67,179.89 279.48,186.01 274.78,176.45  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 288.93,
    y1: 186.95,
    x2: 304.68,
    y2: 177.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M284.74,180.34c0.12,9.36-6.62,18.5-8.77,27.61c-1.59,6.72-0.82,13.74,0.01,20.6 c0.64,5.27,1.31,10.54,2.02,15.8"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M259.66,181.82c-0.77,2.87-1.23,5.83-1.35,8.8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M238.89,216.92c0.43-7.03,0.86-11.99,3.47-18.54c2.61-6.54,10.13-14.68,16.33-16.5 c-5.23,13.01-8.2,57.23-1.98,85.34h-15.19"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M271.9,255.13c1.78,1.58,3.42,2.59,5.35,3.77c1.77,1.08,6.48,2.05,8.55,2.11h3.04l-1.99-14.26 c-0.12,0.04,0.13,0,0,0l-1.57-0.04c-5.63-1.02-11.54-2.6-17.09-3.96c-6.19,2.68-10.87,5.93-15.76,10.24 c-1.07,0.94-0.88,2.65,0.36,3.35c0.07,0.04,0.14,0.08,0.22,0.12c0,0-0.27,0.58,0.15,1.29c0.58,0.97,1.64,0.94,2.55,1.03 c0.83,0.08,2.77-1.09,2.77-1.09s0.86,1.16,1.45,1.1c2.52-0.24,4.89-0.92,7.42-1.83C268.65,256.49,271.9,255.13,271.9,255.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M252.64,256.27c4.02-2.72,7.95-5.56,11.8-8.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M259.84,258.5c-0.91-0.23-1.25-0.73-1.33-1.26c-0.12-0.77,0.3-1.53,0.95-1.96 c3.64-2.42,7.18-5,10.49-7.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M284.1,257.18c-2.65-0.26-5.21-1.3-7.32-2.92c-0.93-0.72-2.19-0.83-3.24-0.29 c-2.52,1.31-5.04,2.49-7.65,3.65c-0.88,0.39-1.98-0.09-2.15-1.04c-0.01-0.09-0.02-0.17-0.02-0.25 c0.01-0.6,11.38-8.94,11.38-8.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.33,178.88c8.44,1.4,15.88,6.66,21.36,13.24c5.48,6.57,9.19,14.42,12.45,22.33 c4.3,10.43,8.02,22.28,11,34c2.42,9.52-5.53,18.86-15.35,19.29c-20.57,0.91-50.88,0.3-50.88,0.16l-4.05-34.01l16.5,1 l12.82,1.65c0,0-10.7-27.47-9.48-44.49C305.91,189.06,311.33,178.88,311.33,178.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M315.62,236.55c0,0-11.26-26.95-9.32-43.9c0.97-8.51,5.27-12.64,5.27-12.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "324.7,236.74 285.86,233.89 289.58,267.83  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 301.86,
    y1: 235.05,
    x2: 303.44,
    y2: 267.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.56,202.04c-0.66-7.5,2.46-15.23,8.14-20.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M315.36,236.05c2.35-1.48,4.69-2.96,7.04-4.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M343.87,265.09c4.3-1.37,7.89-4.81,9.44-9.05"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "300.47,170.41 279.2,171.95 279.28,149.26 300.1,149.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M300.47,170.41l-15.8,9.48l-5.47-7.94c0,0,4.7-9.89,10.49-9.89 C295.48,162.06,300.47,170.41,300.47,170.41z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st28",
    points: "298.88,154.28 279.2,170.27 279.2,162.84  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.8,122.56c-2.2,6.78-8.34,11.86-14.71,15.05C270.34,130.42,275.13,123.21,283.8,122.56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M301.73,143.1c-0.1,5.38-1.09,11.1-5.29,14.84c-2.06,1.84-4.57,3.11-7.17,4.02 c-3.88,1.36-8.94,2.52-12.98,1.4c-4.67-1.29-6.78-5.72-7.59-10.16c-0.58-3.21-0.61-6.52-0.44-9.78 c0.58-11.08,6.3-20.42,15.96-20.42C297.67,123,301.93,132,301.73,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M306.56,146.04c-0.19,3.39-2.82,6-5.88,5.83c-3.06-0.17-5.38-3.06-5.19-6.44c0.19-3.39,2.82-6,5.88-5.83 C304.43,139.76,306.75,142.65,306.56,146.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M271.74,144.76c0,1.48-1.2,2.67-2.67,2.67c-0.26,0-0.51-0.04-0.75-0.11c-0.04-0.01-0.15-0.06-0.15-0.06 s-0.06-1.42,0.01-2.82c0.06-1.23,0.17-2.27,0.17-2.27s0.15-0.04,0.21-0.05c0.16-0.03,0.33-0.05,0.51-0.05 C270.54,142.09,271.74,143.28,271.74,144.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M292.08,144.76c0,1.48-1.2,2.67-2.67,2.67c-1.48,0-2.67-1.2-2.67-2.67s1.2-2.67,2.67-2.67 C290.88,142.09,292.08,143.28,292.08,144.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M279.85,139.53c-1.46,2.11-3.31,4.54-3.1,5.8c0.2,1.26,1.51,2.23,2.77,2.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M275.47,141.97c0,0.45-0.36,0.81-0.81,0.81c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81 C275.11,141.16,275.47,141.52,275.47,141.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.03,141.97c0,0.45-0.36,0.81-0.81,0.81c-0.45,0-0.81-0.36-0.81-0.81c0-0.45,0.36-0.81,0.81-0.81 C284.67,141.16,285.03,141.52,285.03,141.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M275.4,151.26c1.58,1.43,3.99,1.86,5.96,1.05"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.31,162.62c-4.43,2.56-10.1,1.04-12.66-3.39c-2.56-4.43,3.39-10.89,3.39-12.66 c0-2.29,10.1-1.04,12.66,3.39C319.26,154.39,317.74,160.06,313.31,162.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.51,147.79c-0.25-5.06-1.07-10.18-3.32-14.72s-6.05-8.47-10.87-10.03c-3.51-1.14-7.34-0.96-10.94-0.14 c3.47,2.48,6.62,5.41,9.49,8.56C296.9,137,300.84,144.44,307.51,147.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.81,140.14c-9.14-0.44-19.18-7.82-22.06-16.5c5.96-2.46,11.98-1.03,16.29,2.92 C299.56,129.81,301.56,132.97,301.81,140.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M281.48,126.92c-2.77,3.56-6.64,7.25-10.36,9.81c-1.06,0.73-2.55,1.39-3.52,0.55 c-0.59-0.52-0.69-1.39-0.65-2.18c0.09-1.72,1.21-3.94,1.99-5.47c0.98-1.94,2.35-3.73,4.16-4.94c1.15-0.76,2.45-1.28,3.78-1.63 c2.12-0.55,4.44-0.68,6.43,0.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M300.86,158.05c0.75,4,3.96,7.27,7.25,7.63c3.32,0.36,6.67-1.59,8.36-4.47c1.69-2.88,1.81-6.53,0.71-9.68 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M280.68,126.39c-0.53,8.38,9.15,12.63,16.26,10.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M268.06,136.88c-1.03-0.87-1.35-2.33-1.29-3.68c0.24-6.27,8.07-13.63,14.26-8.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M285.84,153.63h3.73c4.45-0.8,10.68-3.53,13.59-6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M288.84,154.77h-2.76c-0.67,0-1.22-0.55-1.22-1.22l0,0c0-0.67,0.55-1.22,1.22-1.22h2.76 c0.67,0,1.22,0.55,1.22,1.22l0,0C290.06,154.22,289.51,154.77,288.84,154.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M304.36,144.28c0,2.42-0.96,4.95-2.7,5.83c0,0-1.49,0-2.16,0c-2.69,0-4.86-2.61-4.86-5.83 c0-3.22,2.18-5.83,4.86-5.83h1.91C303.3,139.24,304.36,141.73,304.36,144.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M297.8,142.1c0.58-4.52-0.63-9.26-3.33-12.94c-2.2-3.01-5.55-5.56-9.1-6.81 c-0.12-0.04-0.36-0.12-0.36-0.12l0-0.51l3.59,0.06c4.47,0,9.73,6.09,11.11,10.34c1.39,4.25,1.6,8.77,1.96,13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M306.14,144.28c0,3.22-2.18,5.83-4.86,5.83c-2.69,0-4.86-2.61-4.86-5.83c0-3.22,2.18-5.83,4.86-5.83 C303.96,138.44,306.14,141.05,306.14,144.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M299.18,142.1c0.58-4.52-0.63-9.26-3.33-12.94c-2.69-3.68-6.35-6.63-10.84-7.44h4.97 c0.8,0.02,3.83,1.1,5.62,2.62c2.54,2.16,4.69,5.28,5.5,7.78c1.39,4.25,1.6,8.77,1.96,13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M303.18,144.32c0,1.21-0.76,2.19-1.7,2.19c-0.94,0-1.7-0.98-1.7-2.19c0-1.21,0.76-2.19,1.7-2.19 C302.42,142.13,303.18,143.11,303.18,144.32z"
  }))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "236.71,267.89 289.15,267.89 288.5,262.3 236.71,262.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M246.44,267.89l-28.67-55.53c-1.3-2.53-3.91-4.11-6.75-4.11h-72.58c-3.18,0-5.25,3.34-3.84,6.19l23.96,48.34 c1.83,3.16,5.2,5.11,8.86,5.11H246.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.28,267.89l-28.67-55.53c-1.3-2.53-3.91-4.11-6.75-4.11h-72.58c-3.18,0-5.25,3.34-3.84,6.19l23.96,48.34 c1.83,3.16,5.2,5.11,8.86,5.11H240.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M211.88,221.8l-3.02-5.85c-1.3-2.53-3.91-4.11-6.75-4.11h-20.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M180.46,242.29c2.59,1.69,5.74,1.44,7.03-0.56c1.3-1.99,0.25-4.97-2.34-6.66c-2.59-1.69-5.74-1.44-7.03,0.56 C176.82,237.62,177.87,240.6,180.46,242.29z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M361.37,98.06h-39.22c-2.49,0-4.38-2.26-3.93-4.71l1.54-8.33l1.66-9.02c0.35-1.89,2-3.27,3.93-3.27h39.22 c2.49,0,4.38,2.26,3.93,4.71l-1.43,7.77l-1.76,9.58C364.95,96.68,363.3,98.06,361.37,98.06z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "322.03,72.72 341.36,87.06 369.36,72.72  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 323.36,
    y1: 95.56,
    x2: 344.88,
    y2: 95.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.86,95.56c0.17,0,0.33,0,0.5,0h3.04"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d914b475a66754bef80937033f16cd62.svg";
export { ForwardRef as ReactComponent };